import React from "react";
import { PageTitleProps } from "./PageTitle.types";
import {
  Box,
  Button,
  Form,
  Grid,
  IconButton,
  TextControl,
  TruncateTooltip,
  Typography,
} from "..";
import Edit from "@tiny/icons/generated/Edit";
import { usePageTitle } from "./PageTitle.hooks";
import useBreakpoints from "../hooks/useBreakpoints";
import { useStyles } from "./PageTitle.styles";

function PageTitle(props: PageTitleProps) {
  const {
    chip,
    onTitleEdit,
    subTitle,
    title,
    titleEditLabel,
    titleEditDisabled,
    titleEditDisabledTooltip,
    titleEditing,
    titleEditable,
    titleMaxLength,
    titleSaving,
    form,
    cancelEdit,
    saveTitle,
    titleKeyDown,
    titleSize,
  } = usePageTitle(props);

  const mdUp = useBreakpoints();
  const classes = useStyles();
  const titleVariant = () => {
    if (titleSize === "big") {
      return mdUp ? "h1" : "h2";
    }
    return mdUp ? "h3" : "h4";
  };

  return (
    <>
      {titleEditing ? (
        <Form form={form} onSubmit={saveTitle} className={classes.form}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <TextControl
                name="name"
                onKeyDown={titleKeyDown}
                autoFocus
                label={titleEditLabel}
                required
                maxLength={titleMaxLength}
              />
            </Grid>
            <Grid item>
              <Button variant="contained" disabled={titleSaving} type="submit">
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={cancelEdit}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Form>
      ) : (
        <>
          <Box className={classes.titleContainer}>
            <TruncateTooltip>
              <Typography
                variant={titleVariant()}
                fontWeight="semiBold"
                m={0}
                color="grey"
                tone={900}
                noWrap
                className={classes.title}
              >
                {title}
              </Typography>
            </TruncateTooltip>
          </Box>
          {chip}
          {subTitle && (
            <Typography
              color="grey"
              tone={700}
              variant="body2"
              display="block"
              mt={1}
            >
              {subTitle}
            </Typography>
          )}
          {titleEditable && mdUp && (
            <IconButton
              size="small"
              className={classes.editIcon}
              onClick={onTitleEdit}
              disabled={titleEditDisabled}
              disabledTooltip={titleEditDisabledTooltip}
            >
              <Edit />
            </IconButton>
          )}
        </>
      )}
    </>
  );
}

export default PageTitle;
